import countries from 'i18n-iso-countries'

/**
 * Accepts a 2-3-digit country code and converts it to a 3-digit country code using i18n-iso-countries.
 *
 * @param countryCode Case insensitive 2- or 3-digit country code
 */
export const convert2DigitCountryCodeTo3Digit = (countryCode: string): string | null => {
  if (!countryCode || !countries.isValid(countryCode)) return null
  if (countryCode.length === 2) {
    const converted = countries.alpha2ToAlpha3(countryCode.toUpperCase())
    return converted?.toUpperCase() || countryCode
  }
  return countryCode
}
